// User
const tokenKey = 'token'
const UserInfoKey = 'userInfo'
/* ,{Domain: '.xlcwx.com',path: '/'} */
/* 用户信息 */
export const getInfo = () =>
  localStorage.getItem(UserInfoKey)
    ? JSON.parse(localStorage.getItem(UserInfoKey))
    : null
export const setInfo = (UserInfo) =>
  localStorage.setItem(UserInfoKey, JSON.stringify(UserInfo))
export const getToken = () => localStorage.getItem(tokenKey)
export const setToken = (token) => localStorage.setItem(tokenKey, token)
/* 是否有未读消息 */
 
/* 入驻商Token */
const domainTokenKey = 'DomainAuthorization'
export const getDomainToken = () =>
  localStorage.getItem(domainTokenKey)
    ? localStorage.getItem(domainTokenKey)
    : null
export const setDomainToken = (unReadyVal) =>
  localStorage.setItem(domainTokenKey, unReadyVal)
/* 入驻商*/
const domainKey = 'domain'
export const getDomain = () =>
  localStorage.getItem(domainKey)
    ? JSON.parse(localStorage.getItem(domainKey))
    : null
export const setDomain = (logo) =>
  localStorage.setItem(domainKey, JSON.stringify(
    logo))
/* 入驻商标志：兼容旧标志缓存和当前域名配置中的标志字段。 */
export const getDomainLogo = () => {
  const cachedLogo = localStorage.getItem('domainLogo')
  if (cachedLogo) return cachedLogo
  const domain = getDomain() || {}
  return domain.qyLogo || domain.logoImg || null
}
 export const setUserInfo = (logo) =>
  localStorage.setItem('userInfo', JSON.stringify(
    logo))
     export const getUserInfo = () =>
  localStorage.getItem('userInfo')
    ? JSON.parse(localStorage.getItem('userInfo'))
    : null
